import React from 'react'

const Folder = props => (
    <svg {...props}>
        <path d="M32.515 7l-5-7H6v4H3v4H0v52h60V7H32.515zM2 58V10h18.485l5 7h.012l4.69 6.551c.195.272.502.417.813.418V24h27v34H2zm56-36H31.537l-3.579-5H58v5zm0-7H26.525l-4.712-6.582-.001-.001L21.515 8H5V6h18.485l5 7H58v2zm-28.485-4l-5-7H8V2h18.485l5 7H58v2H29.515z"></path>
        <path d="M27 55h28V35H27v20zm2-18h24v16H29V37z"></path>
        <path d="M33 40H43V42H33z"></path>
        <path d="M33 44H49V46H33z"></path>
        <path d="M33 48H49V50H33z"></path>
    </svg>
)

export default Folder
